<template>
  <svg
    width="9"
    height="18"
    viewBox="0 0 9 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.399772 17.0528C-0.133257 16.459 -0.133257 15.4999 0.399772 14.9061L5.70273 8.99904L0.399772 3.09196C-0.133258 2.49821 -0.133258 1.53907 0.399772 0.945314C0.932801 0.351562 1.79385 0.351562 2.32688 0.945314L8.60023 7.93333C9.13326 8.52708 9.13326 9.48622 8.60023 10.08L2.32688 17.068C1.80752 17.6465 0.932802 17.6465 0.399772 17.0528Z"
      fill="var(--primary-blue)"
    />
  </svg>
</template>
